module.exports = __webpack_public_path__ + "img/avatar-68.28fea37f.png";